import { noop } from 'lodash';
import { createContext } from 'react';

import { BorrowerAchAccountId, LoanId, RepayAccountId } from '@willow/types-iso';

interface AutopayContext {
  showConfirmAutopayModal: boolean;
  setShowConfirmAutopayModal: (val: boolean) => void;
  showDisableAutopayModal: boolean;
  setShowDisableAutopayModal: (val: boolean) => void;
  updateDwollaAutopaySettings: (loanId: LoanId, bankUrl?: string) => Promise<any>;
  updateRepayAutopaySettings: (loanId: LoanId, accountId?: RepayAccountId, dayOfTheMonth?: number) => Promise<any>;
  updateNachaAutopaySettings: (
    loanId: LoanId,
    accountId?: BorrowerAchAccountId,
    dayOfTheMonth?: number,
  ) => Promise<any>;
  updateDwollaAutopaySettingsLoading: boolean;
  updateRepayAutopaySettingsLoading: boolean;
  updateNachaAutopaySettingsLoading: boolean;
}

export const AutopayContext = createContext<AutopayContext>({
  showConfirmAutopayModal: false,
  showDisableAutopayModal: false,
  setShowConfirmAutopayModal: noop,
  setShowDisableAutopayModal: noop,
  updateDwollaAutopaySettings: async () => {},
  updateRepayAutopaySettings: async () => {},
  updateNachaAutopaySettings: async () => {},
  updateDwollaAutopaySettingsLoading: false,
  updateRepayAutopaySettingsLoading: false,
  updateNachaAutopaySettingsLoading: false,
});
